'use client';

export { default } from './SpeedDialIcon';
export { default as speedDialIconClasses } from './speedDialIconClasses';
export * from './speedDialIconClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/SpeedDialIcon/index.js
// module id = 882
// module chunks = 22